import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import MapComponent from "../../components/Map/MapComponent";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import LocationMapComponent from "../../components/Map/LocationMapComponent";
import { images } from "../../config/images";

const ProductMap = ({ mapLocationData,  setNearByStateSelected, setNearByCitySelected, locationStatusChoice }) => {
    const [isSolarFullScreen, setIsFullscreen] = useState(false);
    const { isFullscreen } = useSelector((state) => state.headerState);
    const [originalHeight, setOriginalHeight] = useState(null);
    const mapRef = useRef(null);
    useEffect(() => {
        const mapContainer = document.getElementById("map-container");
        if (!mapContainer) return;
      
        // Store original height when component mounts
        const containerHeight = mapContainer.offsetHeight;
        setOriginalHeight(containerHeight);
        console.log("Stored original height:", containerHeight);
      
        const handleFullscreenChange = () => {
          if (document.fullscreenElement === mapContainer) {
            // Entering fullscreen
            setIsFullscreen(true);
          } else {
            // Exiting fullscreen
            setIsFullscreen(false);
            
            // Restore original height with a small delay
            setTimeout(() => {
              if (originalHeight) {
                mapContainer.style.height = `${originalHeight}px`;
                console.log("Restored height to:", originalHeight);
                
                // Trigger map resize if using Mappls/MapmyIndia
                if (window.mappls && mapRef.current) {
                  setTimeout(() => {
                    window.mappls.event.trigger(mapRef.current, 'resize');
                  }, 100);
                }
              }
            }, 100); // Small delay to ensure DOM update
          }
        };
      
        // Add all fullscreen event listeners
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
        document.addEventListener("MSFullscreenChange", handleFullscreenChange);
      
        return () => {
          document.removeEventListener("fullscreenchange", handleFullscreenChange);
          document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
          document.removeEventListener("MSFullscreenChange", handleFullscreenChange);
        };
      }, [originalHeight]); // Add originalHeight to dependencies

      const toggleFullscreen = () => {
        const mapContainer = document.getElementById("map-container");
        if (!mapContainer) return;
      
        if (!document.fullscreenElement) {
          // Store current height before entering fullscreen
          const currentHeight = mapContainer.offsetHeight;
          setOriginalHeight(currentHeight);
          console.log("Storing height before fullscreen:", currentHeight);
      
          // Enter fullscreen
          setIsFullscreen(true);
          try {
            if (mapContainer.requestFullscreen) {
              mapContainer.requestFullscreen();
            } else if (mapContainer.webkitRequestFullscreen) {
              mapContainer.webkitRequestFullscreen();
            } else if (mapContainer.msRequestFullscreen) {
              mapContainer.msRequestFullscreen();
            }
          } catch (error) {
            console.error("Fullscreen request failed:", error);
            setIsFullscreen(false);
          }
        } else {
          // Exit fullscreen
          setIsFullscreen(false);
          try {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
            }
          } catch (error) {
            console.error("Fullscreen exit failed:", error);
            setIsFullscreen(true);
          }
        }
      };

    
    return (
        <div className="product-map-inner">
            {/* <button
                onClick={toggleFullscreen}
                className={`fullscreen-button ${isSolarFullScreen ? 'fullscreen' : ''} product-fullscreen-button`}
            >
                {isSolarFullScreen ? (
                    <CloseFullscreenIcon className="fullscreen-icon" />
                ) : (
                    <OpenInFullIcon className="fullscreen-icon" />
                )}
            </button> */}
             {isSolarFullScreen ? (
                      // <CloseFullscreenIcon className="fullscreen-icon" />
                      <img
                      src={images.resizeButton1}
                      onClick={toggleFullscreen}
                      alt="resize"
                      style={{right:"2px"}}
                      className={`fullscreen-button ${
                        isSolarFullScreen ? "fullscreen" : ""
                      }`}
                    />
                    ) : (
                      // <OpenInFullIcon className="fullscreen-icon" />
                      <img
                        src={images.resizeButton}
                        onClick={toggleFullscreen}
                        alt="resize"
                        style={{right:"2px"}}
                        className={`fullscreen-button ${
                          isSolarFullScreen ? "fullscreen" : ""
                        }`}
                      />
                    )}
            <LocationMapComponent
                type="Product"
                isSolarFullScreen={isSolarFullScreen}
                isFullscreen={isFullscreen}
                mapData={mapLocationData}
                setNearByStateSelected={setNearByStateSelected}
                setNearByCitySelected={setNearByCitySelected}
                locationStatusChoice={locationStatusChoice}
            />

        </div>
    )
}
export default ProductMap;